import joi from 'joi';
import joiDateExtensions from '@joi/date';

const joiDate = joi.extend(joiDateExtensions);
const timestamp = joiDate.date().utc();
const datetime = timestamp.format('YYYY-MM-DDTHH:mm:ss[Z]').raw();

const CAPACITY_SUBSCRIPTION_SCHEMA = joi.object({
  id: joi.string().uuid(),
  marketPartyId: joi.string().uuid(),
  startDate: datetime.required(),
  endDate: datetime.greater(joi.ref('startDate')).required(),
  subscribedCapacity: joi.number().precision(3).min(0.001).required(),
  pricePerMWh: joi.number().precision(3).min(0),
  createdAt: datetime,
  createdBy: joi.string(),
});

export {
  CAPACITY_SUBSCRIPTION_SCHEMA,
};

export default CAPACITY_SUBSCRIPTION_SCHEMA;
